import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export type DateTypes = 'short' | 'long' | 'withTime';

const dateFormats: Record<DateTypes, Intl.DateTimeFormatOptions> = {
  short: {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  },
  long: {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  },
  withTime: {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  },
};

export function formatDate(
  isoDateString: string,
  format: DateTypes = 'withTime'
): string {
  const date = new Date(isoDateString);
  if (isNaN(date.getTime())) return '';

  const formatter = new Intl.DateTimeFormat(
    navigator.language,
    dateFormats[format]
  );

  return formatter.format(date);
}

export const formatReadingTime = (minutes: number) =>
  `${minutes} ${minutes === 1 ? 'minute' : 'minutes'} read`;
